import { useEffect, useState } from "react";
import api from "./api";

// True when running inside the admin Site Content preview iframe (?scPreview=1),
// where draft copy arrives from the parent via postMessage instead of the API.
export const IS_SC_PREVIEW_FRAME =
  typeof window !== "undefined" && new URLSearchParams(window.location.search).has("scPreview");

let _draft = null;
const _draftListeners = new Set();
if (IS_SC_PREVIEW_FRAME) {
  window.addEventListener("message", (e) => {
    if (e.origin === window.location.origin && e.data?.type === "sc-preview" && e.data.content) {
      _draft = e.data.content;
      _draftListeners.forEach((fn) => fn(_draft));
    }
  });
}

// Session-level cache of admin-editable site copy blocks.
let _cache = null;
let _inflight = null;

export function useSiteContent() {
  const [content, setContent] = useState(_cache);
  const [draft, setDraft] = useState(_draft);
  useEffect(() => {
    if (!IS_SC_PREVIEW_FRAME) return;
    const fn = (d) => setDraft({ ...d });
    _draftListeners.add(fn);
    return () => _draftListeners.delete(fn);
  }, []);
  useEffect(() => {
    if (_cache) { setContent(_cache); return; }
    if (!_inflight) _inflight = api.get("/site-content").then((r) => { _cache = r.data; return r.data; }).catch(() => ({}));
    let active = true;
    _inflight.then((d) => { if (active) setContent(d); });
    return () => { active = false; };
  }, []);
  return draft || content || {};
}
